import { ContractsComponent } from './contracts.component';
import { ContractsListComponent } from './list/contracts.list.component';
import { ContractsSingleIndexComponent } from './single-index/contracts.single.index.component';
import { ContractsAccrualsComponent } from './accruals/contracts.accruals.component';
import { ContractsPaymentsComponent } from './payments/contracts.payment.component';
import { ContractsDocumentationComponent } from './documentation/contracts.documentation.component';
import { ContractsObjectsComponent } from './objects/contracts.objects.component';
import { ContractsPrivilegesComponent } from './privileges/contracts.privileges.component';
import { ContractsPostponementComponent } from './postponement/contracts.postponement.component';

import { ContractResolver } from '../../../resolves/contract.resolver';

export const ContractsRoutes: Array<any> = [
  {
    path: 'contracts',
    component: ContractsComponent,
    canActivate: [],
    children: [
      {
        path: '',
        component: ContractsListComponent,
        children: []
      },
      {
        path: ':id',
        component: ContractsSingleIndexComponent,
        resolve: {
          data: ContractResolver
        },
        children: [
          {
            path: '',
            redirectTo: 'accruals',
            pathMatch: 'full',
          },
          {
            path: 'accruals',
            component: ContractsAccrualsComponent,
          },
          {
            path: 'payments',
            component: ContractsPaymentsComponent,
          },
          {
            path: 'documentation',
            component: ContractsDocumentationComponent,
          },
          {
            path: 'objects',
            component: ContractsObjectsComponent,
          },
          {
            path: 'privileges',
            component: ContractsPrivilegesComponent,
          },
          {
            path: 'postponement',
            component: ContractsPostponementComponent,
          },
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/contracts.routes.ts